import { Outlet } from 'react-router-dom';

// ==============================|| MINIMAL LAYOUT ||============================== //
// use for login page

const MinimalLayout = () => (
    <>
        <Outlet />
    </>
);

export default MinimalLayout;
